const header = () => {
    const hamburger = document.querySelector(".hamburger");
    let isActive = false;

    document.addEventListener("scrolling", e => handleScrollEvents(e.detail));

    hamburger && hamburgerInit();

    function hamburgerInit() {
        hamburger.addEventListener("click", hamburgerToggle);
    }

    function hamburgerToggle() {
        isActive = !isActive;
        document.body.dataset.isMenuOpen = isActive;

        const event = new CustomEvent("menuToggled", { detail: { isOpen: isActive } });
        document.dispatchEvent(event);
    }
};

const handleScrollEvents = ({ direction, position }) => {
    const homepageHero = document.querySelector(".hero-homepage");
    const header = document.querySelector(".header-main");
    const hidePosition = 150;
    header.dataset.shrink = homepageHero
        ? position >= homepageHero.clientHeight - window.innerHeight
        : position >= hidePosition;
    header.dataset.shy = position >= hidePosition && direction === "down";
};

export default header;
